<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 5H20a2 2 0 00-2 2v41a2 2 0 002 2h33a2 2 0 002-2V7a2 2 0 00-2-2zm-1 42H21V8h31z"/><path d="M43 56H12V17h3.5v-3H11a2 2 0 00-2 2v41a2 2 0 002 2h33a2 2 0 002-2v-4.5h-3z"/></svg>